import { ButtonLink, TooltipProvider } from 'slab'
import { type MoneyAmount } from 'types'
import { type UserFacingEnrollmentMetadata } from 'types/member_onboarding_v2'

import { CompletedOnboardingSidebar } from '../components/CompletedOnboardingSidebar'
import Header from '../components/Header'
import { ProfileMenu } from '../components/ProfileMenu'
import SummarySidebar from '../components/SummarySidebar'
import PostEnrollmentActions from '../PostEnrollmentActions'
import { type QmeTreatment } from '../types'

type Props = {
  enrollments?: Array<UserFacingEnrollmentMetadata>;
  memberName?: string;
  coverageStartDate?: string;
  companyName?: string;
  payByBank?: boolean;
  allowanceAmount: MoneyAmount;
  totalPremiumsAmount: MoneyAmount;
  qmeTreatment: QmeTreatment;
  userId?: string;
  delayCard: boolean;
  isMemberOnTieredAllowance: boolean;
  isThisEnrollmentForRenewal: boolean;
}

const PostEnrollmentPage = (props: Props) => {
  const {
    memberName,
    coverageStartDate,
    qmeTreatment,
    allowanceAmount,
    totalPremiumsAmount,
    enrollments,
    companyName,
    payByBank,
    userId,
    delayCard,
    isMemberOnTieredAllowance,
    isThisEnrollmentForRenewal,
  } = props

  const coverageStart = coverageStartDate
    ? new Date(`${coverageStartDate}T00:00:00`)
    : new Date()

  return (
    <TooltipProvider>
      <div className='flex bg-white h-screen overflow-hidden isolate'>
        <aside className='hidden xl:flex flex-col flex-shrink-0 p-10 gap-y-10'>
          <ProfileMenu memberName={memberName} withoutContext />
          <div className='pl-3 flex-1'>
            <CompletedOnboardingSidebar
              isThisEnrollmentForRenewal={isThisEnrollmentForRenewal}
            />
          </div>
        </aside>
        <main className='flex-1 min-w-0 overflow-y-auto'>
          <div className='flex flex-col gap-y-8 pt-[110px] pb-[100px] px-6 md:px-12 xl:px-[100px]'>
            <Header
              title="We've got your enrollments! 🎉"
              subtitle='Just a few more steps to get everything squared away:'
            />

            <PostEnrollmentActions
              enrollments={enrollments}
              coverageStartDate={coverageStart}
              companyName={companyName}
              payByBank={payByBank}
              allowanceAmount={allowanceAmount}
              totalPremiumsAmount={totalPremiumsAmount}
              qmeTreatment={qmeTreatment}
              userId={userId}
              delayCard={delayCard}
            />
            <div className='flex justify-end'>
              <ButtonLink href='/' variant='primary' size='large'>
                Go to dashboard →
              </ButtonLink>
            </div>
          </div>
        </main>
        <div className='hidden md:block flex-shrink-0 overflow-y-auto bg-gray-50 shadow-default relative z-10 min-w-[360px]'>
          <SummarySidebar
            enrollments={enrollments}
            coverageStartDate={coverageStart}
            allowanceAmount={allowanceAmount}
            totalPremiumsAmount={totalPremiumsAmount}
            isMemberOnTieredAllowance={isMemberOnTieredAllowance}
          />
        </div>
      </div>
    </TooltipProvider>
  )
}

export default PostEnrollmentPage
